import axios from 'axios';

function _fetchData(fetchData) {
	let loader = this.$loading.show();
	fetchData()
		.then(data => {
			Object.assign(this.$data, data);
			//console.log(data);
		})
		.catch(error => {
			if(error.response) {
				this.$awn.alert(`Impossibile scaricare i dati: '${error.response.data.detail}'`);
			}
			else {
				this.$awn.alert(`Impossibile scaricare i dati: '${error}'`);
			}
			return error;
		})
		.finally(() => {
			loader.hide();
		});
}

export default {
	data() {
		return {
			busy: false
		}
	},

	methods: {
		asyncGet(api) {
			return axios.get(api)
				.catch(error => {
					this.$awn.alert("Si è verificato un errore: " + error);
				});
		},

		asyncPost(api, payload) {
			return axios.post(api, payload)
				.catch(error => {
					this.$awn.alert("Si è verificato un errore: " + error);
				});
		},

		refresh() {
			if(this.fetchData) {
				this.fetchData();
			}
		}
	},

	created() {
		// Checks whether there is a custom fetch data handler
		// and invoked it by wrapping it with the loader overlay.
		const fetchData = this.$options.fetchData;
		if(fetchData && fetchData instanceof Function) {
			this.fetchData = _fetchData.bind(this, fetchData.bind(this));
		}

		// Adds a simple wrapper funciton that handle custom component's
		// functions that send asynchronous data to server.
		const asyncMethods = this.$options.asyncMethods;
		if(asyncMethods && asyncMethods instanceof Object) {
			// For each functions contained, wrap it with the global
			// logic of Thenable.
			Object.keys(asyncMethods).forEach(funcName => {
				const func = asyncMethods[funcName];
				this[funcName] = function() {
					//console.log("CALLED: ", funcName, this, arguments);
					let loader = this.$loading.show();
					this.busy = true;
					//this.$awn.info("Download dei dati in corso...");
		
					let ret = func.apply(this, arguments);
					if(!ret || !(ret instanceof Promise)) {
						loader.hide();
						this.busy = false;
						console.warn("Function in asyncMethods does not return any Promise");
						return ret;
					}

					return ret.then(response => {
						console.log("ASYNC::response", response);
						this.$awn.success("Operazione eseguita con successo");

						// if(response.status == 200) {
						// 	this.$awn.success("Operazione eseguita con successo");
						// }
						// else if (response.status > 200 && response.status < 300) {
						// 	this.$awn.warning(`L'operazione eseguita con eccezione: '${response.data.detail}'`);
						// }
						return response;
					})
					.catch(error => {
						console.error("ASYNC::error", error);
						if(!error) {
							this.$awn.alert("Attenzione, errore interno");
							return;
						}

						if(!error.response) {
							return error;
						}

						if(error.response.status == 400) {
							this.$awn.alert("Richiesta malformata");
						}
						else if(error.response.status == 404) {
							this.$awn.alert("Impossibile comunicare con il server");
						}
						else if(error.response.status == 405) {
							this.$awn.alert("Servizio non raggiungibile");
						}
						else if(error.response.status == 500) {
							this.$awn.alert("Il server ha risposto con un errore");
						}
						else {
							//this.$awn.alert(`Si è verificato un errore: '${error.response.data.detail}'`);
							this.$awn.alert(`Si è verificato un errore generico: '${error.response}'`);
						}

						return error;
					})
					.finally(() => {
						loader.hide();
						this.busy = false;
					});
				}.bind(this);
			});
		}
	},

	mounted() {
		if(this.fetchData) {
			this.fetchData();
		}
	}
}